var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 1.75,
    fill: "#fff",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "CA_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 1.75,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#CA_svg__a)",
    fill: "#FF3131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0h8v20h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20h8V0H0v20zM16.111 9.222a.333.333 0 01-.562-.301l.45-2.254-1.333.667-.666-2-.667 2L12 6.667l.45 2.254a.333.333 0 01-.562.3l-.32-.318a.333.333 0 00-.47 0l-.432.43-1.333-.666L10 10l-.431.431a.333.333 0 000 .472l1.764 1.764h2l.333 2h.667l.333-2h2l1.765-1.764a.333.333 0 000-.472l-.431-.43.666-1.334-1.333.667-.431-.431a.333.333 0 00-.471 0l-.32.319z"
  }))));
}
export default SvgCa;